import SectionHeader from "@/components/base/SectionHeader";

const stacks = [
  {
    title: "Frontend",
    icon: "ri-layout-5-line",
    items: ["React", "Next.js", "Tailwind CSS"],
  },
  {
    title: "Backend",
    icon: "ri-server-line",
    items: ["Node.js", "Express", "PostgreSQL"],
  },
  {
    title: "Infrastructure & Tools",
    icon: "ri-cloud-line",
    items: [
      "APIs",
      "Cloud services",
      "Authentication",
      "Database systems",
      "Automation platforms",
      "AI integrations",
    ],
  },
];

export default function Technology() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px]">
        <div className="max-w-3xl">
          <SectionHeader
            eyebrow="Built With Modern Technology"
            title="Business problem → Solution → Technology."
            subtitle="The technology is a means to an end, not the selling point. Here's how we build solutions that are reliable, maintainable and ready to grow."
          />
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {stacks.map((s) => (
            <div
              key={s.title}
              className="rounded-lg border border-background-200 bg-background-50 p-7"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={`${s.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {s.title}
              </h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {s.items.map((item) => (
                  <span
                    key={item}
                    className="rounded-md bg-background-100 px-3 py-1.5 text-sm text-foreground-700 border border-background-200"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}